'use client';

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useState } from 'react';

import { NavLink } from './app-header-nav';
import styles from './app-header-nav-default.module.scss';

interface AppHeaderNavDefaultProps {
  navLinks: NavLink[];
  testId?: string;
}

export const AppHeaderNavDefault = ({ navLinks, testId }: AppHeaderNavDefaultProps) => {
  const [open, setOpen] = useState(false);
  const flattenNavLinks = (links: NavLink[]): NavLink[] =>
    links.flatMap((link) => {
      if (!link.children?.length) return link;

      const nestedLinks = flattenNavLinks(link.children);
      const linkWithoutChildren = { ...link, children: undefined };

      return linkWithoutChildren.onClick ? [linkWithoutChildren, ...nestedLinks] : nestedLinks;
    });
  const flattenedNavLinks = flattenNavLinks(navLinks);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <Box
      className={styles.AppHeaderNavDefault}
      data-testid={testId}
    >
      <IconButton
        aria-controls="menu-appbar"
        aria-haspopup="true"
        data-testid={testId && `${testId}-toggleDrawerButton`}
        onClick={toggleDrawer(true)}
        size="large"
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
      >
        <Box
          className={styles.drawer}
          onClick={toggleDrawer(false)}
          role="presentation"
        >
          <IconButton
            className={styles.closeButton}
            data-testid={testId && `${testId}-closeDrawerButton`}
            onClick={toggleDrawer(false)}
            size="small"
          >
            <CloseIcon />
          </IconButton>
          <List>
            {flattenedNavLinks.map(({ isActive = false, isDisabled = false, label, onClick = undefined }) => (
              <ListItem
                key={label}
                disablePadding
              >
                <ListItemButton
                  data-testid={testId && `${testId}-menuItem-${label}`}
                  disabled={Boolean(isDisabled && !isActive)}
                  onClick={onClick}
                >
                  <ListItemText primary={label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};
